import { axiosClient } from "@/shared/api/axios-client";
import type { ConfiguracionDocumental } from "@/features/admin-gestion-documental/configuracion-documental";

/**
 * Gestión Documental (fase 2) · tipo de documento dentro de su CATEGORÍA (antes «tipo de
 * documento adicional»). `sobrescrituras` = lo que cambia respecto a su categoría (null = hereda).
 */
export interface TipoDocumentoAdmin {
  id: string;
  categoria: string;
  categoriaNombre: string;
  nombre: string;
  orden: number;
  activo: boolean;
  sobrescrituras: ConfiguracionDocumental;
}

export interface CrearTipoDocumentoInput {
  categoria: string;
  nombre: string;
}

export interface EditarTipoDocumentoInput {
  nombre: string;
  activo: boolean;
  orden?: number;
  sobrescrituras?: ConfiguracionDocumental;
}

export interface ListarTiposDocumentoParams {
  categoria?: string;
  busqueda?: string;
  page?: number;
  pageSize?: number;
}

/** Envelope paginado del backend + conteos del catálogo completo para el header. */
export interface PaginaTiposDocumento {
  items: TipoDocumentoAdmin[];
  total: number;
  page: number;
  pageSize: number;
  totalCatalogo: number;
  totalActivos: number;
}

export async function listarTiposDocumentoAdmin(params: ListarTiposDocumentoParams = {}): Promise<PaginaTiposDocumento> {
  const { data } = await axiosClient.get<PaginaTiposDocumento>("/api/admin/tipos-documento", { params });
  return data;
}

export async function crearTipoDocumento(input: CrearTipoDocumentoInput): Promise<TipoDocumentoAdmin> {
  const { data } = await axiosClient.post<TipoDocumentoAdmin>("/api/admin/tipos-documento", input);
  return data;
}

export async function editarTipoDocumento(id: string, input: EditarTipoDocumentoInput): Promise<TipoDocumentoAdmin> {
  const { data } = await axiosClient.put<TipoDocumentoAdmin>(`/api/admin/tipos-documento/${id}`, input);
  return data;
}

export async function eliminarTipoDocumento(id: string): Promise<void> {
  await axiosClient.delete(`/api/admin/tipos-documento/${id}`);
}
